export default "__VITE_ASSET__6f44ddbb__"